import HomeContainer from './containers/HomeContainer';

export default HomeContainer;
